import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ScheduleUserTask } from 'src/app/classes';
import { User } from 'src/app/lib/user/classes';
import { UserService } from 'src/app/lib/user/services/user.service';
import { Issue } from '../../../classes';
import { IIssueProviderService, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-assign-user-form2',
  templateUrl: './assign-user-form2.component.html',
  styleUrls: ['./assign-user-form2.component.css']
})
export class AssignUserForm2Component implements OnDestroy, OnInit {

  @Input() center: boolean = false;
  @Input() disabled: boolean = false;

  initialUserAssigment = { };
  userScheduleReadOnly = { };

  formGroup: FormGroup;

  users$ = this._userService.loadAllAMSUsers(true);

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) private _service: IIssueProviderService,
    private _controlContainer: ControlContainer,
    private _issueService: IssueService,
    private _formBuilder: FormBuilder,
    private _userService: UserService
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      users: this._controlContainer.control as FormArray
    });
    this._subscriptions.push(...[
      combineLatest([this._userService.loadAllAMSUsers(), this._service.issueId$.pipe(switchMap((issueId: number) => this._issueService.getAssignedUsers(issueId)))]).subscribe(([users, assignedUserIds]) => {
        this.setUp(assignedUserIds, users);
      })
    ]);
  }

  setUp(assignedUserIds: string[], users: User[]){
    for(let user of users){
      this.initialUserAssigment[user.id] = assignedUserIds.indexOf(user.id) > -1;
      let task = (this.userControl.value as ScheduleUserTask[]).find(x => x.user.id === user.id);
      if(task) this.userScheduleReadOnly[user.id] = task.schedule;
      else this.userScheduleReadOnly[user.id] = this.initialUserAssigment[user.id];
    }
  }

  toggleAssignment(user: User){
    if(this.disabled) return;
    this._service.issue$.pipe(take(1)).subscribe((issue: Issue) => {
      let index = this.userControl.controls.findIndex((x: AbstractControl) => (x.value as ScheduleUserTask).user.id === user.id);
      if(this.userScheduleReadOnly[user.id]){
        if(this.initialUserAssigment[user.id]){
          if(index > -1) (this.userControl.controls[index] as FormGroup).controls['schedule'].setValue(false);
          else this.userControl.push(this._formBuilder.group({
            'issue': issue,
            'schedule': false,
            'user': user
          }));
        } else if(index > -1) this.userControl.removeAt(index);
        this.userScheduleReadOnly[user.id] = false;
      } else {
        if(!this.initialUserAssigment[user.id]){
          if(index > -1) (this.userControl.controls[index] as FormGroup).controls['schedule'].setValue(true);
          else this.userControl.push(this._formBuilder.group({
            'issue': issue,
            'schedule': true,
            'user': user
          }));
        } else if(index > -1) this.userControl.removeAt(index);
        this.userScheduleReadOnly[user.id] = true;
      }
      this.userControl.value.length > 0? this.userControl.markAsDirty(): this.userControl.markAsPristine();
    });
  }

  get userControl(): FormArray {
    return this.formGroup.controls['users'] as FormArray;
  }

}
